<template>
<div>
    <div class="im-label">
        {{ $t('reservations.modal.client') }}
    </div>
    <div class="major mt-1">
        {{ item.customer.first_name }} {{ item.customer.last_name }}
        <span v-if="extra_info">
            <img :src="genius" alt="" height="18">
        </span>
    </div>
    <div class="regular pt-1">
        <v-icon class="px-1" size="18">place</v-icon>
        {{ item.customer.contact.address.city }}
        <span v-if="item.customer.contact.address.city&&item.customer.contact.address.region">,</span>
        {{ item.customer.contact.address.region }}
    </div>
    <div class="regular pt-1" v-if="item.customer.contact.phone">
        <v-icon class="px-1" size="16">phone</v-icon>
        <span>{{ item.customer.contact.phone }}</span>
    </div>
    <div class="regular pt-1" v-if="item.customer.contact.email">
        <v-icon class="px-1" size="16">mail</v-icon>
        <span>{{ item.customer.contact.email }}</span>
    </div>

    <slot name="client_observations">
        <div class="im-label pt-2">{{ $t('dashboard.reservations.modal.client_observations') }}:</div>
        <div class="regular" v-if="item.meta">
            <span v-if="item.meta.reservation.customer.remarks._value">{{ item.meta.reservation.customer.remarks._value }}</span>
            <span v-else> - </span>
        </div>
        <div class="regular" v-else>
            <span v-if="item.observations.client">{{ item.observations.client }}</span>
            <span v-else> - </span>
        </div>
    </slot>

</div>
</template>

<script>
import defaults from "../../../utils/PropDefaults.js";
import Genius from '../../../../assets/genius-tag.svg';

export default {

    props: {
        item: {
            type: Object,
            default: function () {
                return defaults.reservation_item
            }
        },
    },

    computed: {
        extra_info() {
            try {
                this.item.meta.reservation.reservation_extra_info.flags.flag._attribute.name == 'booker_is_genius'
                return true
            } catch (e) {
                return false
            }
        }

    },

    data: () => {
        return {
            genius: Genius,
            text_more_less: false,
            show_more: false,
        }
    },
    methods: {

        textMoreLess(value) {
            if(value) {
                if(value.length > 99) {
                    this.text_more_less = true;
                    if(!this.show_more) {
                        return value.substr(0, 100) + " ... "
                    } else {
                        return value
                    }
                } else {
                    this.text_more_less = false;
                    return value
                }

            } else {
                this.text_more_less = false;
                return "-"
            }
        },

    },
}
</script>
